module.exports = __webpack_public_path__ + "static/logoTDSI-eb9512e5a32ad57937ce72bc9acc7c28.png";